import { useEffect } from "react";

/**
 * useDataRefresh — attaches a callback that runs whenever the app broadcasts
 * a "handymeister:data-updated" event (fired by admin save handlers), when
 * the window regains focus, or when another tab writes the localStorage
 * invalidation key.
 *
 * Usage:
 *   useEffect(() => { fetchData(); }, []);
 *   useDataRefresh(fetchData);
 */
export function useDataRefresh(callback) {
  useEffect(() => {
    if (typeof callback !== "function") return undefined;
    const handler = () => callback();
    const onStorage = (e) => { if (e.key === "handymeister:data-updated") callback(); };
    window.addEventListener("focus", handler);
    window.addEventListener("handymeister:data-updated", handler);
    window.addEventListener("storage", onStorage);
    return () => {
      window.removeEventListener("focus", handler);
      window.removeEventListener("handymeister:data-updated", handler);
      window.removeEventListener("storage", onStorage);
    };
  }, [callback]);
}
